import React, { useState } from "react";
import CommonModal from "./CommonModal";

const calculatorButtons = [
  "1", "2", "3", "10+",
  "4", "5", "6", "20+",
  "7", "8", "9", "50+",
  ".", "0", "CE", "100+"
];

const RevenueCalculatorModal = ({ isOpen, onClose, onSave, title, defaultValue }) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");

  const handleButtonClick = (val) => {
    if (val === "CE") {
      setInputValue("");
    } else if (val.includes("+")) {
      const addValue = parseFloat(val.replace("+", ""));
      setInputValue((prev) => (Number(prev || 0) + addValue).toString());
    } else {
      setInputValue((prev) => prev + val);
    }
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="revenueCalcModal" size="lg">
      <div className="modal-header">
        <h1 className="modal-title mdTitle">{title || "POS Cash"}</h1>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>
      <div className="modal-body">
        <div className="modalBodyStyle formStyle">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Add value"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <div className="row g-0 cashCalculator">
              {calculatorButtons.map((btn, i) => (
                <div key={i} className="col-3 ccCol">
                  <button
                    type="button"
                    className="btn cashCalBtn"
                    onClick={() => handleButtonClick(btn)}
                  >
                    {btn}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer justify-content-between">
        <button type="button" className="btn btnLight" onClick={onClose}>
          Close
        </button>
        <button
          type="button"
          className="btn btnPrimary"
          onClick={() => onSave(inputValue)}
        >
          Save Changes
        </button>
      </div>
    </CommonModal>
  );
};

export default RevenueCalculatorModal;
